cv.PayRouter = Marionette.AppRouter.extend({
  routes: {
    // Payment
    "pay?*params": "pay",
    "pay/iframe?*params": "pay",

    // Preview stuff
    "l/campaigns/(:id)/preview": "preview",

    "*other": "notFound",
  },

  initialize: function (options) {},

  before: function (route, params) {
    this.publicView = new cv.PublicView();
    cv.rootView.content.attachView(this.publicView);
  },

  after: function (route, params) {
    var preview_routes = ["l/campaigns/(:id)/preview"];
    if ($.inArray(route, preview_routes) > -1) {
      vent.trigger("app:enter_preview");
    } else {
      vent.trigger("app:exit_preview");
    }
  },

  notFound: function (segment) {
    top.location = segment;
  },

  preview: function (stub) {},

  pay: function () {},
});

cv.AuthRouter = Marionette.AppRouter.extend({
  routes: {
    // Authentication
    login: "login",
    "login?*params": "login",
    signup: "signup",
    "signup?*params": "signup",
    invite: "invite",
    resend_activation: "resendActivation",
    forgot_password: "forgotPassword",
    "reset_password/:any/:any": "resetPassword",

    "*other": "notFound",
  },

  initialize: function (options) {},

  notFound: function (segment) {
    top.location = segment;
  },

  before: function (route, params) {
    this.publicView = new cv.PublicView();
    cv.rootView.content.attachView(this.publicView);
  },

  login: function (params_string) {
    this.publicView.showChildView(
      "auth",
      new cv.LoginView({
        params: _.isNull(params_string) ? {} : $.deparam(params_string),
      })
    );
  },

  signup: function (params_string) {
    this.publicView.showChildView(
      "auth",
      new cv.SignupView({
        params: _.isNull(params_string) ? {} : $.deparam(params_string),
      })
    );
  },

  resendActivation: function () {
    this.publicView.showChildView("auth", new cv.ResendActivationView());
  },

  forgotPassword: function () {
    this.publicView.showChildView("auth", new cv.ForgotPasswordView());
  },

  resetPassword: function (user_id, pass_key) {
    this.publicView.showChildView(
      "auth",
      new cv.ResetPasswordView({
        user_id: user_id,
        pass_key: pass_key,
      })
    );
  },
});

cv.AdminRouter = Backbone.SubRoute.extend({
  routes: {
    "": "dashboard",

    // Admin
    dashboard: "dashboard",
    "account(/)": "account",
    "account/:section": "account",
    "page(/)": "page",
    "page/:section": "page",
    email: "email",

    donations: "donations",

    posts: "posts",
    "posts/add(/)": "postEdit",
    "posts/:tab": "posts",
    "posts/edit/:id": "postEdit",
    "posts/edit/:id/:tab": "postEdit",
  },

  initialize: function (options) {},

  after: function (route, params) {},

  before: function (route, params) {
    if (cv.PRELOADED.logged_in == false) {
      top.location = "/";
    }

    // If the user isn't setup the redirect them to the setup
    if (
      !moment(cv.project.get("user_updated")).isValid() ||
      !moment(cv.project.get("project_updated")).isValid()
    ) {
      top.location = "/fundraiser_setup";
      return false;
    }

    // If registration is enabled and not paid then redirect to setup
    if (
      cv.campaign.get("enable_p2p_registrations") == 1 &&
      _.isEmpty(cv.project.get("registration"))
    ) {
      top.location = "/fundraiser_setup/registration";
      return false;
    }

    // Reset breadcrumbs and go normal
    vent.trigger("tray:go_normal");
    vent.trigger("tray:reset_crumbs");

    // Attach the public view if it hasn't been already
    if (_.isUndefined(cv.rootView.content.currentView)) {
      cv.rootView.content.attachView(new cv.PublicView());
    }
  },

  account: function (section) {
    vent.trigger("tray:add_crumb", {
      title: "My Account",
      stub: "account",
    });

    if (_.isNull(section)) {
      var view = new cv.AccountView({});
    } else {
      if (section == "profile") {
        vent.trigger("tray:add_crumb", {
          title: "Profile",
        });

        var view = new cv.ProfileView({
          model: cv.user,
        });
      }
      if (section == "additional_info") {
        vent.trigger("tray:add_crumb", {
          title: "Additional Info",
        });

        var view = new cv.AdditionalInfoView({
          model: cv.project,
        });
      }
      if (section == "notifications") {
        vent.trigger("tray:add_crumb", {
          title: "Notifications",
        });

        var view = new cv.NotificationsView({
          model: cv.project,
        });
      }
      if (section == "change_email") {
        vent.trigger("tray:add_crumb", {
          title: "Change E-mail",
        });

        var view = new cv.ChangeEmailView({});
      }
      if (section == "change_password") {
        vent.trigger("tray:add_crumb", {
          title: "Change Password",
        });

        var view = new cv.ChangePasswordView({});
      }
    }
    vent.trigger("tray:show", view);
  },

  dashboard: function () {
    var view = new cv.DashboardView({});
    vent.trigger("tray:show", view);
  },

  email: function () {
    vent.trigger("tray:add_crumb", {
      title: "Send E-mail",
      stub: "email",
    });

    var view = new cv.EmailView({});
    vent.trigger("tray:show", view);
  },

  donations: function () {
    vent.trigger("tray:add_crumb", {
      title: "Donations",
      stub: "donations",
    });

    var view = new cv.DonationsView({
      collection: new cv.Donations(null, {
        params: {
          project_id: cv.project.get("id"),
          params: {},
        },
      }),
    });
    vent.trigger("tray:show", view);
  },

  page: function (section) {
    vent.trigger("tray:add_crumb", {
      title: "Edit Page",
      stub: "page",
    });

    if (_.isNull(section)) {
      var view = new cv.PageView({
        model: cv.project,
      });
    } else {
      if (section == "details") {
        vent.trigger("tray:add_crumb", {
          title: "Details",
        });

        var view = new cv.PageGeneralView({
          model: cv.project,
        });
      }
      if (section == "appeal") {
        vent.trigger("tray:go_wide");
        vent.trigger("tray:add_crumb", {
          title: "Appeal",
        });

        var view = new cv.PageAppealView({
          model: cv.project,
        });
      }
      if (section == "share") {
        vent.trigger("tray:add_crumb", {
          title: "Share Settings",
        });

        var view = new cv.PageShareView({
          model: cv.project,
        });
      }
    }
    vent.trigger("tray:show", view);
  },

  posts: function (tab) {
    vent.trigger("tray:add_crumb", {
      title: "Updates",
    });

    if (_.isNull(tab)) {
      cv.adminRouter.navigate("posts/drafts", { trigger: true });
      return;
    }

    var view = new cv.PostsView({
      collection: new cv.Posts(),
      tab: tab,
    });
    vent.trigger("tray:show", view);
  },

  postEdit: function (id, tab) {
    vent.trigger("tray:go_wide");
    vent.trigger("tray:add_crumb", {
      title: "Updates",
      stub: "posts",
    });

    if (!_.isNull(id)) {
      vent.trigger("tray:add_crumb", {
        title: "Edit Update",
        stub: "posts/edit/" + id,
      });

      var model = new cv.Post({
        id: id,
      });
    } else {
      vent.trigger("tray:add_crumb", {
        title: "New Update",
      });

      var model = new cv.Post();
    }

    // Must check null and undefined
    if (!_.isNull(tab) && !_.isUndefined(tab)) {
      if (tab == "share") {
        vent.trigger("tray:add_crumb", {
          title: "Edit Share",
        });

        var view = new cv.PostShareView({
          model: model,
        });
      }
      if (tab == "details") {
        vent.trigger("tray:add_crumb", {
          title: "Edit Details",
        });

        var view = new cv.PostDetailsView({
          model: model,
        });
      }
    } else {
      var view = new cv.PostEditView({
        model: model,
      });
    }
    vent.trigger("tray:show", view);
  },

  share: function (tab) {
    var view = new cv.ShareView({
      tab: tab,
      model: cv.project,
    });
    vent.trigger("tray:show", view);
  },
});

cv.TeamAdminRouter = Backbone.SubRoute.extend({
  routes: {
    "": "dashboard",

    // Admin
    dashboard: "dashboard",
    "page(/)": "page",
    "page/:section": "page",
    "donations(/)": "donations",
    "members(/)": "members",
  },

  initialize: function (options) {
    this.team_model = options.team_model;
  },

  after: function (route, params) {},

  before: function (route, params) {
    // Reset breadcrumbs and go normal
    vent.trigger("tray:go_normal");
    vent.trigger("tray:reset_crumbs");

    if (_.isUndefined(cv.rootView.content.currentView)) {
      cv.rootView.content.attachView(new cv.PublicView());
    }
  },

  dashboard: function () {
    var view = new cv.TeamView({
      model: this.team_model,
    });
    vent.trigger("tray:show", view);
  },

  page: function (section) {
    vent.trigger("tray:add_crumb", {
      title: "Edit Team Page",
      stub: "page",
    });

    if (_.isNull(section)) {
      var view = new cv.TeamPageView({
        model: this.team_model,
      });
    } else {
      if (section == "details") {
        vent.trigger("tray:add_crumb", {
          title: "Details",
        });

        var view = new cv.TeamDetailsView({
          model: this.team_model,
        });
      }
      if (section == "appeal") {
        vent.trigger("tray:go_wide");
        vent.trigger("tray:add_crumb", {
          title: "Appeal",
        });

        var view = new cv.TeamAppealView({
          model: this.team_model,
        });
      }
      if (section == "sharing") {
        vent.trigger("tray:add_crumb", {
          title: "Sharing",
        });

        var view = new cv.TeamSharingView({
          model: this.team_model,
        });
      }
    }
    vent.trigger("tray:show", view);
  },

  members: function () {
    vent.trigger("tray:add_crumb", {
      title: "Team Members",
    });

    var view = new cv.TeamProjectsView({
      model: this.team_model,
      collection: new cv.Projects(null, {
        params: {
          api_key: cv.PRELOADED.public_api_key,
          team_id: this.team_model.get("id"),
          params: {},
        },
      }),
    });
    vent.trigger("tray:show", view);
  },
});

cv.PublicRouter = Marionette.AppRouter.extend({
  routes: {
    "fundraiser_setup(/)": "setup",
    "fundraiser_setup/:section": "setup",

    "team_setup(/)": "teamSetup",
    "team_setup/:section": "teamSetup",

    "search(/)": "search",
    "search/:tab": "search",
    "search/:tab?*params": "search",

    "team/:stub(/)": "team",
    "blog/:stub(/)": "post",
    ":stub/blog/:post_stub(/)": "post",
    ":stub(/)": "project",
    "": "campaign",

    // Preview stuff
    "l/campaigns/(:id)/preview": "preview",

    "*notFound": "notFound",
  },

  initialize: function (options) {},

  notFound: function (segment) {},

  after: function (route, params) {
    var preview_routes = ["l/campaigns/(:id)/preview"];
    if ($.inArray(route, preview_routes) > -1) {
      vent.trigger("app:enter_preview");
    } else {
      vent.trigger("app:exit_preview");
    }
  },

  before: function (route, params) {
    // Hide the tray if it's open
    vent.trigger("tray:hide");

    // Initialize public view
    this.publicView = new cv.PublicView();
    cv.rootView.content.attachView(this.publicView);
  },

  setup: function (tab) {
    if (cv.PRELOADED.logged_in == false) {
      top.location = "/";
    }

    // If the user isn't setup but we are trying to access the fundraising page, redirect to
    // beginning
    if (
      !moment(cv.project.get("user_updated")).isValid() &&
      _.contains(["registration", "page", "appeal", "share"], tab)
    ) {
      this.navigate("/fundraiser_setup/profile", { trigger: true });
      return false;
    }

    // If registration is enabled and not paid then redirect to setup
    if (
      cv.campaign.get("enable_p2p_registrations") == 1 &&
      _.isEmpty(cv.project.get("registration")) &&
      _.contains(["page", "appeal", "share"], tab)
    ) {
      this.navigate("/fundraiser_setup/registration", { trigger: true });
      return false;
    }

    // If page isn't setup but we are trying to access other sections
    if (
      !moment(cv.project.get("project_updated")).isValid() &&
      _.contains(["appeal", "share"], tab)
    ) {
      this.navigate("/fundraiser_setup/page", { trigger: true });
      return false;
    }

    var view = new cv.Views.SetupView({
      tab: tab,
    });
    this.publicView.showChildView("setup", view);
  },

  teamSetup: function (tab) {
    var view = new cv.Views.Team.SetupView({
      tab: tab,
    });
    this.publicView.showChildView("setup", view);
  },

  campaign: function () {},

  project: function (stub) {},

  team: function (stub) {},

  preview: function (stub) {},

  post: function () {
    // Hacky way to scroll to top of the post
    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop: $("#details").offset().top - 10,
        },
        0
      );
    }, 10);
  },

  search: function (tab, params_string) {
    this.publicView.showChildView(
      "search",
      new cv.PublicSearchView({
        tab: _.isNull(tab) ? "fundraisers" : tab,
        params:
          _.isNull(params_string) || _.isUndefined(params_string) ? {} : $.deparam(params_string),
      })
    );
  },
});
